export const da = {
  "account": {
    "k1": "Starter-pakke",
    "k2": "Modtag 125 credits. Ideel til at komme i gang og afprøve kernefunktionaliteterne.",
    "k3": "Pro-pakke",
    "k4": "Modtag 250 credits. Den mest fordelagtige løsning for regelmæssige brugere.",
    "k5": "Business-pakke",
    "k6": "Modtag 1700 credits. Til superbrugere og virksomheder; inkluderer 25% rabat.",
    "k7": "Enterprise-pakke",
    "k8": "Modtag 5000 credits. Den ultimative pakke til institutionelle klienter med 50% rabat.",
    "k9": "Indlæser kontooplysninger...",
    "k10": "Kontostyring",
    "k11": "Nuværende credits",
    "k12": "Nye brugere modtager 125 credits (værdi $50) for at komme i gang.",
    "k13": "Din credit-beholdning er lav. Køb flere for at sikre uafbrudt adgang til AI-funktionerne.",
    "k14": "Har du en rabatkode?",
    "k15": "Indløs kode",
    "k16": "Køb flere credits",
    "k17": "Køb nu"
  },
  "aIChatWindow": {
    "k1": "Skift AI-assistent",
    "k2": "AI-assistent",
    "k3": "Spørg ind til din portefølje",
    "k4": "Hvordan kan jeg hjælpe dig i dag?",
    "k5": "Stil et spørgsmål..."
  },
  "allActivities": {
    "k1": "Indlæser aktiviteter...",
    "k2": "Komplet log over credit-forbrug",
    "k3": "Ingen aktiviteter at vise."
  },
  "auth": {
    "k1": "CRE Dominion",
    "k2": "Opret konto",
    "k3": "Velkommen tilbage",
    "k4": "Opret en konto for at komme i gang",
    "k5": "Log ind på din konto",
    "k6": "E-mailadresse",
    "k7": "Adgangskode",
    "k8": "Eller fortsæt med",
    "k9": "Google",
    "k10": "Har du allerede en konto? Log ind",
    "k11": "Har du ikke en konto? Opret bruger"
  },
  "bulkLeaseUploader": {
    "k1": "Indlæser ejendomme...",
    "k2": "Fejl:",
    "k3": "Lejekontrakt-uploader",
    "k4": "Ejendom (påkrævet):",
    "k5": "Vælg en ejendom",
    "k6": "Ingen ejendomme fundet. Tilføj venligst en ejendom først.",
    "k7": "Upload filer",
    "k8": "Upload mappe",
    "k9": "Vælg lejekontrakter (PDF, billeder):",
    "k10": "Vælg mappe med lejekontrakter (uploader alle PDF'er/billeder):",
    "k11": "Upload lejekontrakter",
    "k12": "Valgt",
    "k13": "fil",
    "k14": "Historik over uploadede lejekontrakter",
    "k15": "Indlæser historik...",
    "k16": "Ingen upload-historik fundet.",
    "k17": "Job-ID",
    "k18": "Uploadet den",
    "k19": "Antal filer",
    "k20": "Status",
    "k21": "Handlinger",
    "k22": "Vis"
  },
  "bulkLeaseValidator": {
    "k1": "Indlæser bulk-valideringsjob...",
    "k2": "Uploader filer... Denne proces kan tage tid afhængigt af antallet og størrelsen på dokumenterne. Du kan roligt navigere væk; processen fortsætter i baggrunden.",
    "k3": "Ingen poster fundet for dette job-ID.",
    "k4": "Bulk-validering af lejekontrakter (Job-ID:",
    "k5": "Tilbage til lejekontrakt-uploader",
    "k6": "Godkender valgte...",
    "k7": "Godkend valgte lejekontrakter",
    "k8": "Godkender alle...",
    "k9": "Godkend alle afventende lejekontrakter",
    "k10": "Filnavn",
    "k11": "Status",
    "k12": "Handlinger",
    "k13": "Fejl:"
  },
  "calendarEventModal": {
    "k1": "Type:",
    "k2": "Start:",
    "k3": "Slut:",
    "k4": "Ejendoms-ID:",
    "k5": "System Lejemåls-ID:",
    "k6": "Brugerdefineret lejemåls-ID:",
    "k7": "Event-ID:",
    "k8": "Luk"
  },
  "calendarView": {
    "k1": "Indlæser kalender...",
    "k2": "Fejl:",
    "k3": "Kalender over kritiske datoer"
  },
  "calendarViewWrapper": {
    "k1": "Kalender"
  },
  "dashboard": {
    "k1": "Dashboard-oversigt",
    "k2": "Fejl:",
    "k3": "Ingen dashboard-data tilgængelig.",
    "k4": "Ejendomme i alt",
    "k5": "Lejere i alt",
    "k6": "Lejekontrakter i alt",
    "k7": "Udløb af lejekontrakter",
    "k8": "Ejendomsbelægning",
    "k9": "Ejendomstyper",
    "k10": "Tendenser for ledighedsgrad"
  },
  "dealSourcing": {
    "k1": "Indlæser handler...",
    "k2": "Fejl:",
    "k3": "Deal Sourcing & Management",
    "k4": "Rediger investeringscase",
    "k5": "Tilføj ny investeringscase",
    "k6": "Navn på investeringscase",
    "k7": "Vælg transaktionstype",
    "k8": "Erhvervelse",
    "k9": "Afhændelse",
    "k10": "Udvikling",
    "k11": "Vælg status",
    "k12": "Pipeline",
    "k13": "Due Diligence",
    "k14": "Afsluttet",
    "k15": "Tabt",
    "k16": "Tilknyt ejendom (valgfri)",
    "k17": "Målpris",
    "k18": "Budpris",
    "k19": "Closing-dato:",
    "k20": "Kilde",
    "k21": "Beskrivelse",
    "k22": "Opdater investeringscase",
    "k23": "Tilføj investeringscase",
    "k24": "Annuller redigering",
    "k25": "Mine investeringscases",
    "k26": "Ingen investeringscases fundet. Tilføj en ovenfor!",
    "k27": "Status:",
    "k28": "Ejendom:",
    "k29": "Målpris:",
    "k30": "Budpris:",
    "k31": "Kilde:",
    "k32": "Beskrivelse:",
    "k33": "Rediger",
    "k34": "Slet"
  },
  "documents": {
    "k1": "Indlæser dokumenter...",
    "k2": "Fejl:",
    "k3": "Dokumentstyring",
    "k4": "Upload nyt dokument",
    "k5": "Ejendom (påkrævet):",
    "k6": "Vælg en ejendom",
    "k7": "Vælg dokument(er):",
    "k8": "Upload dokument(er)",
    "k9": "Dine dokumenter",
    "k10": "Ingen dokumenter fundet. Upload et ovenfor!",
    "k11": "Type:",
    "k12": "Ejendoms-ID:",
    "k13": "Beskrivelse:",
    "k14": "Uploadet:",
    "k15": "Vis",
    "k16": "Rediger",
    "k17": "Slet"
  },
  "editCompModal": {
    "k1": "Rediger sammenligneligt salg",
    "k2": "Adresse:",
    "k3": "Salgsdato:",
    "k4": "Salgspris:",
    "k5": "Areal (kvadratfod):",
    "k6": "Annuller",
    "k7": "Gem ændringer"
  },
  "editDocumentModal": {
    "k1": "Rediger dokument",
    "k2": "Filnavn:",
    "k3": "Beskrivelse:",
    "k4": "Annuller",
    "k5": "Gem ændringer"
  },
  "editLeaseModal": {
    "k1": "Rediger lejekontrakt",
    "k2": "Brugerdefineret leje-ID:",
    "k3": "Lejernavn:",
    "k4": "Startdato:",
    "k5": "Slutdato:",
    "k6": "Lejebeløb:",
    "k7": "Annuller",
    "k8": "Gem ændringer"
  },
  "editTransactionModal": {
    "k1": "Rediger transaktion",
    "k2": "Type:",
    "k3": "Beskrivelse:",
    "k4": "Beløb:",
    "k5": "Forfaldsdato:",
    "k6": "Betalingsdato:",
    "k7": "Kategori:",
    "k8": "Indtægt",
    "k9": "Udgift",
    "k10": "Annuller",
    "k11": "Gem ændringer"
  },
  "fAQ": {
    "k1": "Hvad er CRE Dominion?",
    "k2": "CRE Dominion er en omfattende, AI-drevet platform designet til professionelle inden for erhvervsejendomme (CRE). Den strømliner ejendomsadministration, deal sourcing, lejekontrakt-abstraktion, markedsanalyse og meget mere, hvilket gør det muligt at træffe datadrevne beslutninger til opbygning af din ejendomsportefølje.",
    "k3": "Hvem er CRE Dominion til?",
    "k4": "CRE Dominion er udviklet til en bred vifte af CRE-professionelle, herunder ejendomsejere, ejendomsadministratorer, asset managers, mæglere og investorer. Uanset om du administrerer en enkelt ejendom eller en stor portefølje, leverer vores platform de nødvendige værktøjer til din succes.",
    "k5": "Hvad er de vigtigste funktioner i CRE Dominion?",
    "k6": "Vores kernefunktioner inkluderer AI-drevet lejekontrakt-abstraktion, avanceret deal sourcing og analyse, omfattende ejendoms- og lejeradministration, markedsanalyse og prædiktive tendenser, ejendomsvurdering, tilpasset rapportering samt sikker dokumenthåndtering.",
    "k7": "Hvordan fungerer funktionen til lejekontrakt-abstraktion?",
    "k8": "Vores AI-drevne værktøj til lejekontrakt-abstraktion udtrækker automatisk nøgleinformationer fra dine lejekontrakter, såsom start- og slutdatoer, lejebeløb, klausuler og meget mere. Dette sparer utallige timer på manuel dataindtastning og reducerer risikoen for fejl.",
    "k9": "Er mine data sikre?",
    "k10": "Ja, datasikkerhed er vores højeste prioritet. Vi anvender brancheførende sikkerhedsforanstaltninger, herunder kryptering og sikker cloud-lagring, for at beskytte dine følsomme oplysninger. Dine data er sikre, beskyttede og altid tilgængelige for dig.",
    "k11": "Hvilke typer ejendomme kan jeg administrere med CRE Dominion?",
    "k12": "Du kan administrere en bred vifte af erhvervsejendomme, herunder kontorbygninger, butikslokaler, industriejendomme og udlejningsejendomme til beboelse.",
    "k13": "Hvordan fungerer deal sourcing-funktionen?",
    "k14": "Vores deal sourcing-modul anvender avancerede algoritmer og markedsdata til at hjælpe dig med at identificere og evaluere potentielle investeringsmuligheder, der matcher dine kriterier. Du kan analysere handler, udføre due diligence og spore din pipeline på ét samlet sted.",
    "k15": "Kan jeg generere tilpassede rapporter?",
    "k16": "Ja, vores platform inkluderer en kraftfuld rapporteringsmotor, der gør det muligt at generere en bred vifte af tilpassede rapporter om porteføljeperformance, finansielle nøgletal, leasingaktivitet og meget mere. Disse rapporter kan skræddersyes til dine interessenters behov.",
    "k17": "Hvad er prismodellen?",
    "k18": "CRE Dominion opererer via et fleksibelt kreditbaseret system. Du køber kreditter, som derefter anvendes til at tilgå forskellige AI-drevne funktioner og avancerede analyseværktøjer. Dette sikrer, at du kun betaler for dit faktiske forbrug, hvilket muliggør skalering i takt med dine specifikke behov. Besøg dine kontoindstillinger for at se muligheder for køb af kreditter og detaljer om dit forbrug.",
    "k19": "Hvordan kommer jeg i gang?",
    "k20": "Det er nemt at komme i gang! Du kan tilmelde dig en gratis prøveperiode direkte via vores hjemmeside. Efter tilmelding kan du med det samme begynde at tilføje dine ejendomme og udforske platformens funktioner.",
    "k21": "&larr; Tilbage til forsiden",
    "k22": "Ofte stillede spørgsmål"
  },
  "financialsLedger": {
    "k1": "Indlæser finansielle data...",
    "k2": "Fejl:",
    "k3": "Indtægter",
    "k4": "Udgifter",
    "k5": "Ingen",
    "k6": "poster fundet.",
    "k7": "Type",
    "k8": "Beskrivelse",
    "k9": "Beløb",
    "k10": "Forfaldsdato",
    "k11": "Betalingsdato",
    "k12": "Handlinger",
    "k13": "Rediger",
    "k14": "Slet",
    "k15": "Tilføj ny finansiel transaktion",
    "k16": "Kategori",
    "k17": "Udgift",
    "k18": "Transaktionstype",
    "k19": "Tilføj transaktion",
    "k20": "Finansielt overblik"
  },
  "homePage": {
    "k1": "Starter Pack",
    "k2": "Ideel til indledende screening af handler og test af AI-baseret lejeabstraktion.",
    "k3": "Pro Pack",
    "k4": "Optimal til aktive opkøbsteams, mæglere og asset managers.",
    "k5": "Business Pack",
    "k6": "Til boutique-fonde, family offices og opkøbsprocesser med høj volumen.",
    "k7": "Enterprise Pack",
    "k8": "Institutionel skalering til REITs, gældsfonde og store porteføljer.",
    "k9": "CRE Dominion | AI-drevet Commercial Real Estate Underwriting &amp; Lease OS",
    "k10": "CRE Dominion Logo",
    "k11": "Live Screener",
    "k12": "Priser",
    "k13": "Videnscenter",
    "k14": "Kontakt",
    "k15": "Log ind",
    "k16": "Institutionel CRE Underwriting",
    "k17": "På 10 sekunder. Ingen regneark.",
    "k18": "Stop med at miste handler pga. langsom manuel due diligence. CRE Dominion kombinerer automatiseret AI-lejeabstraktion med institutionel finansiel modellering på tværs af amerikanske Cap Rates, britiske Net Initial Yields og europæiske metriske standarder.",
    "k19": "Start Live Deal Screener ↓",
    "k20": "Kom i gang gratis (125 credits)",
    "k21": "Intet kreditkort påkrævet",
    "k22": "Kompatibel med USA, UK &amp; Norden/EU",
    "k23": "125 gratis start-credits",
    "k24": "Institutionel workflow-automatisering",
    "k25": "Hele din kommercielle arbejdsgang samlet i én platform.",
    "k26": "Udviklet fra bunden til opkøbsansvarlige, mæglere og private equity-sponsorer, der kræver hastighed uden at gå på kompromis med audit-krav.",
    "k27": "10-sekunders AI-lejeabstraktion",
    "k28": "Udtræk vigtige datoer, lejereguleringer, opsigelsesmuligheder, forsikringsforpligtelser og lejer-covenants fra 80-siders kontrakter på sekunder med 99,9% nøjagtighed.",
    "k29": "Finansiel modellering på tværs af jurisdiktioner",
    "k30": "Indbygget modellering til amerikanske Triple Net (NNN) Cap Rates, britiske Full Repairing &amp; Insuring (FRI) Net Initial Yields og nordiske/europæiske metriske lejekontrakter (`m²`).",
    "k31": "AI-drevet Deal Sourcing &amp; Pipeline",
    "k32": "Centralisér potentielle opkøb, følg budfrister, administrér underwriting-status og generér investor-klare teaser-resuméer i en samlet pipeline.",
    "k33": "Prædiktiv markedsanalyse",
    "k34": "Prognosticér Cap Rate-udvidelser, vakancetendenser og lejevækst i delmarkeder ved hjælp af historisk telemetri og realtidsdata fra sammenlignelige salg.",
    "k35": "Øjeblikkelig værdiansættelse &amp; DCF-scenarier",
    "k36": "Kør discounted cash flow (DCF), direkte kapitalisering og sammenlignelige salgsmodeller side om side for at stressteste din exit Cap Rate og leveraged afkast.",
    "k37": "Enterprise Vault &amp; SOC-sikkerhed",
    "k38": "Isoleret Google Cloud Storage med streng IAM-autorisation. Dine proprietære lejerlister, T-12-rapporter og lejekontrakter deles aldrig og fødes aldrig ind i offentlige LLM'er.",
    "k39": "Interaktiv Live Demo",
    "k40": "Test vores AI-lejekontraktmotor på enhver klausul",
    "k41": "Indsæt en lejeklausul (skadesløsholdelse, opsigelsesret, CPI-regulering, medleje) eller upload en 1-siders aftale nedenfor. Få en øjeblikkelig risikovurdering og forhandlingsanalyse.",
    "k42": "Transparent suveræn prissætning",
    "k43": "Betal kun for det, du analyserer.",
    "k44": "Ingen obligatoriske årlige kontrakter til $5.000 pr. bruger. Ingen salgsdemoer. Start øjeblikkeligt med 125 gratis start-credits ved tilmelding, og fyld op i takt med at din portefølje vokser.",
    "k45": "Mest populær",
    "k46": "engangs",
    "k47": "Ca.",
    "k48": "Analyse-credits",
    "k49": "Kom i gang →",
    "k50": "Har du brug for skræddersyet enterprise-volumen, on-premise-implementeringer eller dedikerede API-kvoter? Kontakt vores ingeniørteam på",
    "k51": "Stop med at lade penge ligge på bordet.",
    "k52": "Slut dig til CRE-professionelle, der bruger AI til at automatisere abstraktion, finde off-market-handler og maksimere porteføljens ROI på tværs af USA, UK og Europa.",
    "k53": "Kom i gang gratis →",
    "k54": "Test Deal Screener",
    "k55": "Intet kreditkort påkrævet • Øjeblikkelig kontooprettelse med 125 gratis credits",
    "k56": "Højpræcisions operativsystem til kommerciel ejendom. Automatiseret AI-lejeabstraktion, underwriting-modellering og porteføljeintelligens.",
    "k57": "&copy;",
    "k58": "CRE Dominion. Alle rettigheder forbeholdes.",
    "k59": "Facebook",
    "k60": "Instagram",
    "k61": "LinkedIn",
    "k62": "Google Play",
    "k63": "Privatlivspolitik",
    "k64": "Servicevilkår",
    "k65": "FAQ"
  },
  "kPISection": {
    "k1": "Se detaljer"
  },
  "leaseAbstraction": {
    "k1": "Lejeabstraktion",
    "k2": "Vælg ejendom:",
    "k3": "-- Vælg en ejendom --",
    "k4": "Upload lejekontrakt (PDF, PNG, JPG):",
    "k5": "Upload & abstraher",
    "k6": "Ekstraherede lejekontrakter",
    "k7": "Lejekontrakt-ID:",
    "k8": "Status:",
    "k9": "Ekstraherede lejedata (ID:",
    "k10": "Godkend lejekontrakt",
    "k11": "Rediger lejekontrakt",
    "k12": "Slet lejekontrakt",
    "k13": "Gem ændringer",
    "k14": "Annuller",
    "k15": "Ejendoms-ID:",
    "k16": "Dokument-URL:",
    "k17": "Vis dokument",
    "k18": "AI-ekstraherede data:",
    "k19": "Lejestartdato:",
    "k20": "Lejeafslutningsdato:",
    "k21": "Månedlig leje:",
    "k22": "Depositum:",
    "k23": "Lejernavn:",
    "k24": "Udlejernavn:",
    "k25": "Ejendomsadresse:",
    "k26": "Ingen specifikke data ekstraheret.",
    "k27": "Fuld ekstraheret tekst:"
  },
  "leaseAbstractionSettings": {
    "k1": "Indlæser indstillinger for lejeabstraktion...",
    "k2": "Indstillinger for lejeabstraktion",
    "k3": "Vælg prædefinerede klausuler:",
    "k4": "Andet (specificer nedenfor)",
    "k5": "Brugerdefinerede klausuler (kommasepareret):",
    "k6": "f.eks. førtidig opsigelsesklausul, fremlejerettigheder",
    "k7": "Gem lejeklausuler"
  },
  "leaseExpirationChart": {
    "k1": "Antal udløbende lejekontrakter",
    "k2": "Lejeudløb pr. måned",
    "k3": "Antal lejekontrakter"
  },
  "leases": {
    "k1": "Fejl:",
    "k2": "Lejemål",
    "k3": "Annuller tilføjelse af nyt lejemål",
    "k4": "Tilføj nyt lejemål",
    "k5": "Lejemåls-uploader",
    "k6": "Lejemålsabstraktion",
    "k7": "Ejendoms-ID:",
    "k8": "Vælg ejendom",
    "k9": "Brugerdefineret lejemåls-ID (valgfrit):",
    "k10": "Brugerdefineret lejemåls-ID",
    "k11": "Lejer:",
    "k12": "Vælg lejer",
    "k13": "Lejemålets startdato:",
    "k14": "Lejemålets slutdato:",
    "k15": "Månedlig leje:",
    "k16": "Månedlig leje",
    "k17": "Lejemålstype:",
    "k18": "Lejemålstype",
    "k19": "Lejeperiode (måneder):",
    "k20": "Lejeperiode (måneder)",
    "k21": "Status:",
    "k22": "Aktiv",
    "k23": "Afventer gennemgang",
    "k24": "Udløbet",
    "k25": "Opsagt",
    "k26": "Noter",
    "k27": "Opret lejemål",
    "k28": "Annuller",
    "k29": "Rediger lejemål (ID:",
    "k30": "Ejendom:",
    "k31": "Vælg lejer (valgfrit)",
    "k32": "Opdater lejemål",
    "k33": "Ingen lejekontrakter fundet",
    "k34": "Lejekontrakt:",
    "k35": "System-ID:",
    "k36": "Udlejer:",
    "k37": "Lejeperiode:",
    "k38": "til",
    "k39": "Leje:",
    "k40": "Depositum:",
    "k41": "Rediger",
    "k42": "Slet",
    "k43": "Vis dokument",
    "k44": "Rådata",
    "k45": "Råekstraherede data",
    "k46": "Luk",
    "k47": "Slet lejekontrakt"
  },
  "marketAnalysis": {
    "k1": "&larr; Tilbage til ejendomme",
    "k2": "Markedsanalyse",
    "k3": "Henter analyse...",
    "k4": "Hent markedsanalyse",
    "k5": "Gem resultat",
    "k6": "Indlæser analyse...",
    "k7": "Markedsanalyse for ejendom",
    "k8": "Detaljer om vurderingsejendom",
    "k9": "Adresse:",
    "k10": "Ejendomstype:",
    "k11": "Areal (kvadratfod):",
    "k12": "Sammenlignelige markedsdata",
    "k13": "Fundne sammenlignelige ejendomme:",
    "k14": "Gennemsnitspris pr. kvm (sammenlignelige):",
    "k15": "Gennemsnitlig salgspris (sammenlignelige):",
    "k16": "Gennemsnitligt areal (sammenlignelige):",
    "k17": "Markedskommentar:",
    "k18": "Resumé:",
    "k19": "Centrale tendenser:",
    "k20": "Anbefaling:"
  },
  "marketComps": {
    "k1": "Indlæser markedssammenligninger...",
    "k2": "Fejl:",
    "k3": "Tilføj nyt sammenligneligt salg",
    "k4": "Adresse",
    "k5": "Salgsdato",
    "k6": "Salgspris",
    "k7": "Areal (kvm)",
    "k8": "Tilføj sammenligningsgrundlag",
    "k9": "Markedssammenligninger",
    "k10": "Ingen markedssammenligninger tilgængelige.",
    "k11": "Pris/kvm",
    "k12": "Handlinger",
    "k13": "Rediger",
    "k14": "Slet"
  },
  "navbar": {
    "k1": "CRE Dominion",
    "k2": "Kerne",
    "k3": "Dashboard",
    "k4": "Ejendomme",
    "k5": "Lejere",
    "k6": "Lejemål",
    "k7": "Dokumenter",
    "k8": "Lejeabstraktion",
    "k9": "Lejeupload",
    "k10": "Vækst",
    "k11": "Deal Sourcing",
    "k12": "Underwriting",
    "k13": "Konto",
    "k14": "Log ud"
  },
  "occupancyChart": {
    "k1": "Belægningsgrad",
    "k2": "Nuværende belægningsgrad",
    "k3": "Procentdel (%)"
  },
  "overduePaymentsSection": {
    "k1": "Forfaldne betalinger",
    "k2": "Forfalden fra:",
    "k3": "Lejemåls-ID:",
    "k4": "Ingen forfaldne betalinger."
  },
  "predictiveTrends": {
    "k1": "&larr; Tilbage til ejendomme",
    "k2": "Prædiktive tendenser",
    "k3": "Indtast et ejendoms-ID...",
    "k4": "Henter tendenser...",
    "k5": "Hent prædiktive tendenser",
    "k6": "Gem resultat",
    "k7": "Tendensforudsigelse for ejendom",
    "k8": "Måldato:",
    "k9": "Forudsagt værdi:",
    "k10": "Konfidensscore:",
    "k11": "Begrundelse:",
    "k12": "Fejl:",
    "k13": "Råt svar:"
  },
  "privacyPolicy": {
    "k1": "&larr; Tilbage til forsiden",
    "k2": "Privatlivspolitik for CRE Dominion",
    "k3": "Denne privatlivspolitik beskriver, hvordan CRE Dominion (\"vi\", \"os\" eller \"vores\") indsamler, anvender og videregiver dine oplysninger, når du benytter vores webapplikation (\"Tjenesten\"). Vi er dedikerede til at beskytte dit privatliv og håndtere dine data på en åben og transparent måde.",
    "k4": "Indsamling og anvendelse af oplysninger",
    "k5": "Vi indsamler forskellige typer oplysninger for at levere og optimere vores Tjeneste til dig. Når du logger ind med Google, indsamler vi personoplysninger såsom dit navn og din e-mailadresse fra din Google-konto. Disse oplysninger anvendes til at oprette og administrere din brugerkonto hos CRE Dominion samt til at personalisere din oplevelse. I takt med at du benytter Tjenesten, kan du give os yderligere data, herunder ejendomsdetaljer, lejekontrakter, lejeroplysninger og andre ejendomsrelaterede data. Dette brugergenererede indhold lagres og behandles for at levere Tjenestens kernefunktionaliteter, såsom lejeabstraktion, ejendomsadministration og markedsanalyse. Vi indsamler også brugsdata, som kan inkludere oplysninger såsom din computers IP-adresse, browsertype, browserversion, hvilke sider af vores Tjeneste du besøger, tidspunkt og dato for dit besøg, tid brugt på disse sider, unikke enheds-id'er og andre diagnostiske data. Disse data hjælper os med at forstå, hvordan vores Tjeneste anvendes, og gør det muligt for os at forbedre dens ydeevne og funktioner.",
    "k6": "Datalagring og -behandling",
    "k7": "Dine data, herunder personoplysninger og brugergenereret indhold, lagres og behandles via Google Clouds økosystem, herunder Google Cloud SQL til databaseadministration, Google Cloud Storage til dokumentlagring samt Google Cloud Vertex AI og Gemini til avancerede analyse- og maskinlæringsfunktioner såsom lejeabstraktion og tendensforudsigelse. Vi sikrer, at der er implementeret passende sikkerhedsforanstaltninger for at beskytte dine data, når de behandles af disse tjenester.",
    "k8": "Cookies og sporingsteknologier",
    "k9": "Vi anvender cookies og lignende sporingsteknologier til at overvåge aktiviteten på vores Tjeneste og gemme visse oplysninger. Cookies er filer med en lille mængde data, der sendes til din browser fra et websted og lagres på din enhed. Der anvendes også sporingsteknologier såsom beacons, tags og scripts til at indsamle og spore oplysninger samt til at forbedre og analysere vores Tjeneste. Du kan instruere din browser til at afvise alle cookies eller angive, hvornår en cookie sendes. Hvis du ikke accepterer cookies, kan du dog muligvis ikke benytte visse dele af vores Tjeneste.",
    "k10": "Videregivelse og deling af data",
    "k11": "Vi sælger ikke dine personoplysninger. Vi kan dele dine oplysninger med tredjeparts-tjenesteudbydere for at facilitere vores Tjeneste, levere Tjenesten på vores vegne, udføre tjenester relateret til Tjenesten eller assistere os med at analysere, hvordan vores Tjeneste anvendes. Disse tredjeparter har kun adgang til dine personoplysninger for at udføre disse opgaver på vores vegne og er forpligtede til ikke at videregive eller anvende dem til andre formål. Vi kan også videregive dine personoplysninger i god tro om, at en sådan handling er nødvendig for at overholde en juridisk forpligtelse, beskytte og forsvare rettigheder eller ejendom tilhørende CRE Dominion, forebygge eller undersøge mulige uregelmæssigheder i forbindelse med Tjenesten, beskytte den personlige sikkerhed for brugere af Tjenesten eller offentligheden, eller beskytte mod juridisk ansvar.",
    "k12": "Dataopbevaring",
    "k13": "Vi opbevarer kun dine personoplysninger, så længe det er nødvendigt til de formål, der er angivet i denne privatlivspolitik. Vi vil opbevare og anvende dine personoplysninger i det omfang, det er nødvendigt for at overholde vores juridiske forpligtelser, løse tvister samt håndhæve vores juridiske aftaler og politikker.",
    "k14": "Dine databeskyttelsesrettigheder",
    "k15": "Afhængigt af din lokation kan du have følgende databeskyttelsesrettigheder: retten til indsigt, opdatering eller sletning af de oplysninger, vi har om dig; retten til berigtigelse; retten til indsigelse; retten til begrænsning af behandling; retten til dataportabilitet; samt retten til at trække dit samtykke tilbage. For at udøve disse rettigheder bedes du kontakte os via nedenstående kontaktoplysninger.",
    "k16": "Anmodninger om sletning af konto og data",
    "k17": "Meddelelse om overholdelse af Google Play-retningslinjer for datasletning:",
    "k18": "CRE Dominion giver brugere fuld kontrol over deres konto og personoplysninger. Du har til enhver tid ret til at anmode om sletning af din konto og alle tilknyttede personoplysninger.",
    "k19": "Sådan anmoder du om sletning af konto og data:",
    "k20": "Send en e-mail til",
    "k21": "med emnelinjen",
    "k22": "\"Account Deletion Request\"",
    "k23": "Inkluder den registrerede e-mailadresse, der er knyttet til din CRE Dominion-konto.",
    "k24": "Vores supportteam vil behandle din anmodning om sletning inden for 7 hverdage og bekræfte, når processen er fuldført.",
    "k25": "Data, der slettes permanent:",
    "k26": "Konto-autentificeringsoplysninger (e-mail, navn, profiloplysninger, UID).",
    "k27": "Uploadede lejekontrakter, PDF-filer og tilpasset dokumentlager.",
    "k28": "Gemte ejendomsprofiler, lejerlister og finansielle værdiansættelsesrapporter.",
    "k29": "Undtagelser for datalagring:",
    "k30": "Visse anonymiserede systemdiagnostiske logfiler eller transaktionsfaktureringsoplysninger kan opbevares midlertidigt for at overholde juridiske forpligtelser, finansielle revisioner eller krav om forebyggelse af svindel i henhold til gældende lovgivning.",
    "k31": "Børns privatliv",
    "k32": "Vores tjeneste er ikke beregnet til brug af børn under 13 år (\"Børn\"). Vi indsamler ikke bevidst personhenførbare oplysninger fra personer under 13 år. Hvis du er forælder eller værge og er bekendt med, at dit barn har givet os personoplysninger, bedes du kontakte os. Hvis vi bliver opmærksomme på, at vi har indsamlet personoplysninger fra børn uden verifikation af forældresamtykke, tager vi skridt til at fjerne disse oplysninger fra vores servere.",
    "k33": "Ændringer til denne privatlivspolitik",
    "k34": "Vi kan opdatere vores privatlivspolitik fra tid til anden. Vi vil give dig besked om eventuelle ændringer ved at offentliggøre den nye privatlivspolitik på denne side. Det anbefales, at du gennemser denne privatlivspolitik med jævne mellemrum for eventuelle ændringer. Ændringer i denne privatlivspolitik træder i kraft, når de offentliggøres på denne side.",
    "k35": "Kontakt os",
    "k36": "Hvis du har spørgsmål til denne privatlivspolitik eller ønsker at anmode om sletning af data, bedes du kontakte os på support@credominion.com."
  },
  "properties": {
    "k1": "Fejl:",
    "k2": "Ejendomme",
    "k3": "Rediger ejendom",
    "k4": "Tilføj ny ejendom",
    "k5": "Auto-udtræk fra OM",
    "k6": "System-ID:",
    "k7": "Adresse",
    "k8": "By",
    "k9": "Stat",
    "k10": "Postnummer",
    "k11": "Ejendomstype",
    "k12": "Ejendoms-ID (valgfri)",
    "k13": "Areal (sq ft)",
    "k14": "Antal enheder",
    "k15": "Købspris",
    "k16": "Nuværende værdi",
    "k17": "Opførselsår",
    "k18": "Beskrivelse",
    "k19": "Opdater ejendom",
    "k20": "Tilføj ejendom",
    "k21": "Annuller redigering",
    "k22": "Dine ejendomme",
    "k23": "Ingen ejendomme fundet",
    "k24": "Type:",
    "k25": "Størrelse:",
    "k26": "sq ft",
    "k27": "Enheder:",
    "k28": "Købspris:",
    "k29": "Nuværende værdi:",
    "k30": "Opførselsår:",
    "k31": "Beskrivelse:",
    "k32": "Rediger",
    "k33": "Slet",
    "k34": "Markedsanalyse",
    "k35": "Værdiansættelse",
    "k36": "Prædiktive tendenser",
    "k37": "Slet ejendom"
  },
  "propertyDetailView": {
    "k1": "Indlæser ejendomsdetaljer...",
    "k2": "Fejl:",
    "k3": "&larr; Tilbage til ejendomme",
    "k4": "Ejendoms-ID:",
    "k5": "Ejendoms-ID",
    "k6": "System-ID",
    "k7": "Ejendomstype",
    "k8": "Areal (kvadratfod)",
    "k9": "sqft",
    "k10": "Antal enheder",
    "k11": "Købspris",
    "k12": "Aktuel værdi",
    "k13": "Opførselsår",
    "k14": "Beskrivelse"
  },
  "propertyDocuments": {
    "k1": "Indlæser dokumenter...",
    "k2": "Fejl:",
    "k3": "Ejendomsdokumenter",
    "k4": "Ingen dokumenter fundet for denne ejendom.",
    "k5": "Type:",
    "k6": "Beskrivelse:",
    "k7": "Uploadet:",
    "k8": "Vis",
    "k9": "Rediger",
    "k10": "Slet"
  },
  "propertyInsights": {
    "k1": "Vis mindre",
    "k2": "Vis mere",
    "k3": "Indlæser ejendomsindsigt...",
    "k4": "Fejl:",
    "k5": "Ejendomsindsigt (AI-ekstraheret)",
    "k6": "Ingen AI-ekstraheret indsigt tilgængelig for denne ejendom endnu.",
    "k7": "Detaljer:",
    "k8": "Kildeuddrag:",
    "k9": "Ekstraheret den:"
  },
  "propertyLeases": {
    "k1": "Indlæser lejemål...",
    "k2": "Fejl:",
    "k3": "Ejendomslejemål",
    "k4": "Ingen lejemål fundet for denne ejendom.",
    "k5": "Lejemål:",
    "k6": "System-ID:",
    "k7": "Lejer:",
    "k8": "Startdato:",
    "k9": "Slutdato:",
    "k10": "Leje:",
    "k11": "Vis",
    "k12": "Rediger",
    "k13": "Slet"
  },
  "propertyTypeChart": {
    "k1": "Antal ejendomme",
    "k2": "Ejendomsfordeling efter type"
  },
  "publicNavbar": {
    "k1": "CRE Dominion",
    "k2": "Forside",
    "k3": "Live Screener",
    "k4": "Videnscenter",
    "k5": "Kontakt",
    "k6": "Log ind"
  },
  "quickActionsSection": {
    "k1": "Hurtige handlinger",
    "k2": "Tilføj ny ejendom",
    "k3": "Tilføj nyt lejemål",
    "k4": "Upload dokument",
    "k5": "Onboarding",
    "k6": "Velkommen til CRE-Dominion!",
    "k7": "Følg disse enkle trin for at komme i gang:",
    "k8": "Tilføj din første ejendom:",
    "k9": "Naviger til sektionen \"Ejendomme\" og klik på \"Tilføj ny ejendom\". Dette er fundamentet for al din ejendomsadministration.",
    "k10": "Upload lejemål:",
    "k11": "Når du har oprettet en ejendom, skal du gå til dens detaljeside og uploade tilhørende lejekontrakter. Vores AI hjælper med at abstrahere nøgleinformationer.",
    "k12": "Administrer dokumenter:",
    "k13": "Brug siden \"Dokumenter\" til at uploade andre relevante filer, såsom årsregnskaber eller markedsrapporter.",
    "k14": "Udforsk funktioner:",
    "k15": "Dyk ned i \"Markeds-comps\", \"Finansielle data\" og \"Kalender\" for at se, hvordan CRE-Dominion kan optimere jeres drift. Tøv ikke med at eksperimentere!",
    "k16": "Forstået!"
  },
  "recentActivitySection": {
    "k1": "Seneste aktivitet",
    "k2": "Ingen nylig aktivitet.",
    "k3": "Vis mere"
  },
  "summaryReportSection": {
    "k1": "Indlæser resumérapport...",
    "k2": "Fejl:",
    "k3": "Resumérapport",
    "k4": "Ejendomme i alt",
    "k5": "Lejere i alt",
    "k6": "Dokumenter i alt",
    "k7": "Gennemsnitlig månedlig leje"
  },
  "tenants": {
    "k1": "Indlæser lejere...",
    "k2": "Fejl:",
    "k3": "Lejere",
    "k4": "Rediger lejer",
    "k5": "Tilføj ny lejer",
    "k6": "Fornavn",
    "k7": "Efternavn",
    "k8": "E-mail",
    "k9": "Telefonnummer",
    "k10": "Fødselsdato:",
    "k11": "Opdater lejer",
    "k12": "Tilføj lejer",
    "k13": "Annuller redigering",
    "k14": "Dine lejere",
    "k15": "Ingen lejere fundet. Tilføj en ovenfor!",
    "k16": "E-mail:",
    "k17": "Telefon:",
    "k18": "Fødselsdato:",
    "k19": "Rediger",
    "k20": "Slet"
  },
  "termsOfService": {
    "k1": "&larr; Tilbage til forsiden",
    "k2": "Servicevilkår for CRE Dominion",
    "k3": "Velkommen til CRE Dominion. Disse Servicevilkår (\"Vilkår\") regulerer din adgang til og brug af CRE Dominion-platformen og tilhørende tjenester (samlet betegnet \"Tjenesten\"). Ved at tilgå eller benytte Tjenesten accepterer du at være bundet af disse Vilkår. Hvis du ikke kan acceptere nogen del af disse vilkår, må du ikke benytte Tjenesten.",
    "k4": "Brugerkonti",
    "k5": "Når du opretter en konto hos os, skal du til enhver tid give os oplysninger, der er nøjagtige, fuldstændige og aktuelle. Manglende overholdelse heraf udgør et brud på Vilkårene, hvilket kan medføre øjeblikkelig opsigelse af din konto på vores Tjeneste. Du er ansvarlig for at beskytte den adgangskode, du bruger til at få adgang til Tjenesten, samt for enhver aktivitet eller handling, der foretages under din adgangskode, uanset om adgangskoden er tilknyttet vores Tjeneste eller en tredjepartstjeneste. Du accepterer ikke at videregive din adgangskode til tredjepart. Du skal straks underrette os, hvis du bliver bekendt med sikkerhedsbrud eller uautoriseret brug af din konto.",
    "k6": "Acceptabel brug",
    "k7": "Du accepterer ikke at bruge Tjenesten til ulovlige formål eller formål, der er forbudt i henhold til disse Vilkår. Du accepterer ikke at bruge Tjenesten på en måde, der kan beskadige, deaktivere, overbelaste eller forringe Tjenesten eller forstyrre andre parters brug og oplevelse af Tjenesten. Du må ikke indhente eller forsøge at indhente materiale eller information via metoder, der ikke er tilsigtet eller stillet til rådighed gennem Tjenesten.",
    "k8": "Intellektuel ejendomsret",
    "k9": "Tjenesten og dens originale indhold (eksklusive indhold leveret af brugere), funktioner og funktionalitet er og forbliver CRE Dominions og dets licensgiveres eksklusive ejendom. Tjenesten er beskyttet af ophavsret, varemærkeret og andre love i både USA og udlandet. Vores varemærker og forretningskendetegn må ikke anvendes i forbindelse med noget produkt eller nogen tjeneste uden forudgående skriftligt samtykke fra CRE Dominion. Du bevarer alle rettigheder til indhold, som du indsender, poster eller viser på eller gennem Tjenesten.",
    "k10": "Links til andre websteder",
    "k11": "Vores Tjeneste kan indeholde links til tredjepartswebsteder eller tjenester, som ikke ejes eller kontrolleres af CRE Dominion. CRE Dominion har ingen kontrol over og påtager sig intet ansvar for indholdet, privatlivspolitikkerne eller praksis hos tredjepartswebsteder eller tjenester. Du anerkender og accepterer endvidere, at CRE Dominion ikke er ansvarlig, direkte eller indirekte, for skader eller tab, der er forårsaget eller påstået at være forårsaget af eller i forbindelse med brugen af eller tilliden til sådant indhold, varer eller tjenester tilgængelige på eller via sådanne websteder eller tjenester. Vi anbefaler på det kraftigste, at du læser vilkår og betingelser samt privatlivspolitikker for alle tredjepartswebsteder eller tjenester, du besøger.",
    "k12": "Opsigelse",
    "k13": "Vi kan opsige eller suspendere din konto øjeblikkeligt, uden forudgående varsel eller ansvar, uanset årsag, herunder uden begrænsning hvis du bryder Vilkårene. Ved opsigelse ophører din ret til at bruge Tjenesten øjeblikkeligt. Hvis du ønsker at opsige din konto, kan du blot ophøre med at bruge Tjenesten.",
    "k14": "Ansvarsfraskrivelse",
    "k15": "Din brug af Tjenesten sker på egen risiko. Tjenesten leveres på et \"AS IS\" og \"AS AVAILABLE\"-grundlag. Tjenesten leveres uden garantier af nogen art, hverken udtrykkelige eller underforståede, herunder, men ikke begrænset til, underforståede garantier om salgbarhed, egnethed til et bestemt formål, ikke-krænkelse eller udførelsesforløb. CRE Dominion garanterer ikke, at Tjenesten vil fungere uafbrudt, sikkert eller være tilgængelig på et bestemt tidspunkt eller sted; at eventuelle fejl eller mangler vil blive rettet; at Tjenesten er fri for vira eller andre skadelige komponenter; eller at resultaterne af brugen af Tjenesten vil opfylde dine krav.",
    "k16": "Ansvarsbegrænsning",
    "k17": "Under ingen omstændigheder kan CRE Dominion, eller dets direktører, medarbejdere, partnere, agenter, leverandører eller associerede selskaber, holdes ansvarlige for indirekte, hændelige, særlige, følgeskader eller pønalerstatninger, herunder men ikke begrænset til tab af fortjeneste, data, brug, goodwill eller andre immaterielle tab, som følge af (i) din adgang til, brug af eller manglende evne til at få adgang til eller bruge tjenesten; (ii) enhver tredjeparts adfærd eller indhold på tjenesten; (iii) ethvert indhold indhentet fra tjenesten; og (iv) uautoriseret adgang, brug eller ændring af dine transmissioner eller indhold, uanset om det er baseret på garanti, kontrakt, erstatningsret (herunder uagtsomhed) eller enhver anden juridisk teori, uanset om vi er blevet informeret om muligheden for en sådan skade, og selv hvis et retsmiddel angivet heri viser sig at have fejlet sit væsentlige formål.",
    "k18": "Lovvalg",
    "k19": "Disse vilkår skal reguleres og fortolkes i overensstemmelse med lovgivningen i staten Californien, USA, uden hensyntagen til dens bestemmelser om lovkonflikter. Vores manglende håndhævelse af en rettighed eller bestemmelse i disse vilkår vil ikke blive betragtet som et afkald på disse rettigheder. Hvis en bestemmelse i disse vilkår kendes ugyldig eller ikke kan håndhæves af en domstol, forbliver de resterende bestemmelser i disse vilkår i kraft. Disse vilkår udgør hele aftalen mellem os vedrørende vores tjeneste og erstatter alle tidligere aftaler, vi måtte have haft mellem os vedrørende tjenesten.",
    "k20": "Ændringer af vilkår",
    "k21": "Vi forbeholder os retten til efter eget skøn at ændre eller erstatte disse vilkår til enhver tid. Hvis en revision er væsentlig, vil vi tilstræbe at give mindst 30 dages varsel, før nye vilkår træder i kraft. Hvad der udgør en væsentlig ændring, bestemmes efter vores eget skøn. Ved at fortsætte med at få adgang til eller bruge vores tjeneste, efter at disse revisioner er trådt i kraft, accepterer du at være bundet af de reviderede vilkår. Hvis du ikke accepterer de nye vilkår, bedes du ophøre med at bruge tjenesten.",
    "k22": "Kontakt os",
    "k23": "Hvis du har spørgsmål til disse vilkår, bedes du kontakte os på support@credominion.com."
  },
  "underwritingToolkit": {
    "k1": "Værktøj til ejendomsvurdering",
    "k2": "Input for ejendom og finansiering",
    "k3": "Købspris",
    "k4": "Årlig bruttolejeindtægt",
    "k5": "Øvrige årlige indtægter (f.eks. parkering, vaskeri)",
    "k6": "Tomgangsrate (%)",
    "k7": "Årlige driftsomkostninger",
    "k8": "Årlige kapitaludgifter (CapEx)",
    "k9": "Lånebeløb",
    "k10": "Rentesats (%)",
    "k11": "Løbetid (år)",
    "k12": "Omkostninger ved låneoptagelse (%)",
    "k13": "Nøgletal",
    "k14": "Effektiv bruttoindtægt",
    "k15": "Netto driftsindtægt (NOI)",
    "k16": "Cap Rate",
    "k17": "Samlet investeret kapital",
    "k18": "Årlig gældsservice",
    "k19": "Årligt cash flow",
    "k20": "Cash-on-Cash afkast",
    "k21": "Gældsdækningsgrad (DSCR)",
    "k22": "Bruttolejemultiplikator (GRM)",
    "k23": "Belåningsgrad (LTV)"
  },
  "upcomingPaymentsSection": {
    "k1": "Kommende betalinger (30 dage)",
    "k2": "Forfald:",
    "k3": "Lejemåls-ID:",
    "k4": "Ingen kommende betalinger."
  },
  "vacancyRateChart": {
    "k1": "Tendenser for tomgangsrate"
  },
  "valuation": {
    "k1": "&larr; Tilbage til ejendomme",
    "k2": "Ejendomsvurdering",
    "k3": "Sammenlignelige salg",
    "k4": "Indkomstmetoden",
    "k5": "Discounted Cash Flow (DCF)",
    "k6": "Omkostningsmetoden",
    "k7": "Henter vurdering...",
    "k8": "Foretag vurdering",
    "k9": "Gem resultat",
    "k10": "Indlæser vurdering...",
    "k11": "Vurdering for ejendom",
    "k12": "Vurderingsresumé:",
    "k13": "Endelig anbefalet værdi:",
    "k14": "Vurderingsdato:",
    "k15": "Vurderingsmetode:",
    "k16": "Antagelser:",
    "k17": "Ansvarsfraskrivelse:",
    "k18": "Vurderingsdetaljer:"
  },
  "articleCard": {
    "k1": "Udgivet:",
    "k2": "Læs mere"
  },
  "leaseInsightWidget": {
    "k1": "Øjeblikkelig AI CRE-indsigt",
    "k2": "Analysér lejekontrakter, regnskaber eller markedsrapporter øjeblikkeligt.",
    "k3": "Indsæt klausul eller resumé",
    "k4": "f.eks. 'Lejer har ret til at opsige dette lejemål, hvis udlejer undlader at levere...'",
    "k5": "Skift dokument",
    "k6": "Upload PDF/Doc",
    "k7": "Understøtter PDF op til 5MB",
    "k8": "Udfør analyse nu →",
    "k9": "Behandler intelligens...",
    "k10": "Prøveperiode udløbet",
    "k11": "Opret gratis arbejdsområde →",
    "k12": "Tilbage til widget",
    "k13": "Konfidensniveau:",
    "k14": "Nulstil",
    "k15": "Executive Summary",
    "k16": "Strategisk handlingsplan",
    "k17": "Lås op for professionel porteføljeanalyse →"
  },
  "bottomCTA": {
    "k1": "Stop med at lade penge",
    "k2": "ligge på bordet.",
    "k3": "Slut dig til 500+ CRE-professionelle, der bruger AI til at automatisere abstraktion, finde off-market handler og maksimere porteføljens ROI.",
    "k4": "Kom i gang gratis →",
    "k5": "Intet kreditkort påkrævet"
  },
  "insufficientCreditsModal": {
    "k1": "Kreditter opbrugt",
    "k2": "Du har opbrugt dine aktive kreditter. Genopfyld nu for at låse op for ubegrænset AI-lejeabstraktion, prædiktiv analyse og automatiserede underwriting-værktøjer.",
    "k3": "Øjeblikkelig lejeabstraktion",
    "k4": "Udtræk nøglebetingelser og finansielle detaljer øjeblikkeligt.",
    "k5": "Underwriting-værktøjskasse",
    "k6": "Generer granulære værdiansættelser og prognoseafkast.",
    "k7": "Prædiktiv trendprognose",
    "k8": "Simuler geografiske og prismæssige skift over tid.",
    "k9": "Markedsanalyse-motor",
    "k10": "Kør sammenligningsanalyser (comps) og makroevalueringer.",
    "k11": "Køb kreditpakker",
    "k12": "Få 125 kreditter for $50 for at fortsætte behandlingen af dine handler.",
    "k13": "Hent kreditter"
  },
  "contact": {
    "k1": "Kontakt CRE Dominion | Institutionel platform for kommerciel ejendom",
    "k2": "Kontakt CRE Dominion",
    "k3": "CRE Dominion",
    "k4": "Direkte assistance",
    "k5": "Har du spørgsmål om AI-lejeabstraktion, værdiansættelses-workflows eller enterprise-porteføljeintegrationer? Vores team af ejendomsteknologer står klar til at hjælpe.",
    "k6": "Kunde- og teknisk support",
    "k7": "Vedrørende kontoanliggender, verificering af lejeabstraktion og teknisk support.",
    "k8": "SLA: Under 4 arbejdstimer",
    "k9": "Forespørgsel afsendt",
    "k10": "Tak for din henvendelse til CRE Dominion. Din besked er blevet videresendt til",
    "k11": ". Hvis dit e-mailprogram ikke åbnede automatisk, kan du klikke nedenfor for at verificere eller sende fra din egen mailklient.",
    "k12": "Åbn i e-mailprogram",
    "k13": "Send en ny besked",
    "k14": "Send en forespørgsel",
    "k15": "Fulde navn *",
    "k16": "Sarah Connor",
    "k17": "Arbejds-e-mail *",
    "k18": "Virksomhed / Portefølje",
    "k19": "Apex Asset Management",
    "k20": "Type af forespørgsel",
    "k21": "Generel support",
    "k22": "Enterprise-licensering",
    "k23": "API-integration",
    "k24": "Fakturering & abonnement",
    "k25": "Sikkerhed & compliance",
    "k26": "Besked *",
    "k27": "Beskriv venligst dine porteføljebehov, ejendomsvolumener eller tekniske spørgsmål...",
    "k28": "Beskyttet af TLS 1.3-kryptering. Vi deler aldrig dine kommercielle data.",
    "k29": "Indsend forespørgsel",
    "k30": "Ofte stillede spørgsmål &rarr;",
    "k31": "Privatlivspolitik",
    "k32": "Servicevilkår",
    "k33": "CRE Videnscenter"
  },
  "instantUnderwritingWidget": {
    "k1": "⚡ Interaktivt Underwriting-værktøj",
    "k2": "Kræver intet login",
    "k3": "Institutionel CRE-underwriting & afkastmodellering",
    "k4": "Skift mellem amerikanske, britiske og europæiske ejendomsstandarder. Øjeblikkelig matematisk validering af deal-metrics.",
    "k5": "🇺🇸 USA",
    "k6": "🇬🇧 Storbritannien",
    "k7": "🇪🇺 Norden &amp; Europa",
    "k8": "Europæisk valuta:",
    "k9": "kr.",
    "k10": "Overholder nordisk KPI-indeksering &amp; metriske standarder (`m²`)",
    "k11": "Hurtige aktiv-presets:",
    "k12": "🏢 Erhvervsejendom / Kontor",
    "k13": "🏭 Logistik / Industri",
    "k14": "🏬 Blandet anvendelse / Boligudlejning",
    "k15": "Købspris / Værdiansættelse (",
    "k16": "Bruttolejeindtægt / år (",
    "k17": "Samlet udlejningsareal (",
    "k18": "Tomgangsrate (%)",
    "k19": "Driftsomkostninger / år (",
    "k20": "Forudsætninger for gæld &amp; finansiering",
    "k21": "Belåningsgrad (LTV) (",
    "k22": "Rentesats (",
    "k23": "Afdragsprofil (",
    "k24": "år)",
    "k25": "Øjeblikkelig afkastprofil",
    "k26": "Verificeret formel",
    "k27": "Driftsresultat (NOI)",
    "k28": "Cash-on-Cash afkast",
    "k29": "Dækningsgrad (DSCR)",
    "k30": "Kontantkøb",
    "k31": "Bruttoafkast",
    "k32": "Årligt cash flow",
    "k33": "Enhedsleje:",
    "k34": "/ år",
    "k35": "Udbetaling:",
    "k36": "Gem handel &amp; eksportér teaser (Gratis)",
    "k37": "Inkluderer 125 gratis start-credits ved tilmelding. Intet kreditkort påkrævet."
  },
  "articleDetailPage": {
    "k1": "Fejl:",
    "k2": "Artiklen blev ikke fundet.",
    "k3": "CRE Dominion",
    "k4": "Tilbage til videnscenter",
    "k5": "• Udgivet",
    "k6": "Om forfatteren",
    "k7": "Hop til toppen",
    "k8": "Læs flere artikler"
  },
  "blogListPage": {
    "k1": "Indlæser blogindlæg...",
    "k2": "Fejl:",
    "k3": "Videnscenter - Ekspertindsigt i erhvervsejendomme | CRE Dominion",
    "k4": "Videnscenter",
    "k5": "Forrige side",
    "k6": "Forrige",
    "k7": "Næste side",
    "k8": "Næste",
    "k9": "Ingen blogindlæg tilgængelige endnu. Følg med!"
  },
  "adminSEOPage": {
    "k1": "Indlæser SEO-administrationspanel...",
    "k2": "Fejl:",
    "k3": "SEO-automatiseringspanel",
    "k4": "Genererede artikler",
    "k5": "Ingen artikler genereret endnu."
  },
  "demoPage": {
    "badge": "60-sekunders interaktiv sandkasse",
    "title": "Erhvervslejeabstraktion & CAM-revision på sekunder",
    "subtitle": "Automatisk revision af erhvervslejekontrakter, CAM-afstemningslofter, nettoprisindekser og lejedifferencer fra lange PDF-aftaler.",
    "step1Title": "Dokumentoverførsel",
    "step1Desc": "Upload 50+ siders erhvervslejekontrakter eller indsæt komplekse CAM- og inflationsklausuler.",
    "step2Title": "AI-klausulabstraktion",
    "step2Desc": "Gemini 3.8 Flash udtrækker basisleje, udgiftsstoppunkter, CAM-lofter, indeksdatoer og revisionsfrister.",
    "step3Title": "Revisionstabel og risici",
    "step3Desc": "Advarer om overfakturering, kumulative CAM-fælder og glemte indeksreguleringer.",
    "widgetHeader": "Interaktiv lejeklausulanalysator",
    "widgetSub": "Indsæt en lejeklausul eller upload et PDF-uddrag nedenfor for at udføre en ekstraktion i realtid.",
    "liveBadge": "Live backend-endepunkt",
    "whyTitle": "Hvorfor ejendomsadministratorer stoler på CRE-Dominion",
    "benefit1Title": "1. Nul manuel indtastning af lejedata",
    "benefit1Desc": "Omdan 80-siders lejekontrakter til verificerede nøgleoversigter på 30 sekunder frem for 4 timer.",
    "benefit2Title": "2. Fang CAM-overfakturering",
    "benefit2Desc": "Krydstjek kontrollerbare vs. ikke-kontrollerbare udgiftslofter før godkendelse af årlig afregning.",
    "benefit3Title": "3. Automatiserede indeksreguleringer",
    "benefit3Desc": "Gå aldrig glip af en årlig inflationsjustering eller varslingsfrist i din erhvervsportefølje.",
    "ctaText": "Klar til at afprøve CRE-Dominion på din egen portefølje?",
    "ctaBtn": "Start gratis 14-dages pilot ->",
    "signIn": "Log ind",
    "requestPilot": "Anmod om pilot"
}
,
  "about": {
    "pageTitle": "Om os & Lederskab | CRE-Dominion Kommerciel Ejendomsintelligens",
    "navHome": "Hjem",
    "navResearch": "Forskning",
    "navContact": "Kontakt",
    "navSignIn": "Log ind",
    "navPilot": "Anmod om pilot",
    "heroBadge": "Institutionel kommerciel ejendomsintelligens",
    "heroTitle": "Udviklet til institutionelle forvaltere & mæglere",
    "heroSubtitle": "CRE-Dominion automatiserer kommerciel lejekontraktsabstraktion, driftsomkostningsafstemning og algoritmisk deal-underwriting. Vi fjerner manuel friktion, så ejendomsoperatører lukker handler med empirisk præcision.",
    "pillar1Title": "Automatiseret lejekontraktsabstraktion",
    "pillar1Desc": "Udtræk lejeplaner, reguleringsklausuler, optioner og kritiske udløbsdatoer fra 80+ siders erhvervslejekontrakter på få sekunder.",
    "pillar2Title": "Prædiktiv underwriting",
    "pillar2Desc": "Algoritmisk værdiansættelsesmotor, der dynamisk stresstester afkastkrav, driftsnetto og gældsdækningsgrader mod markedsdata i realtid.",
    "pillar3Title": "Sikkerhed i bankklasse",
    "pillar3Desc": "Streng kryptografisk multi-tenant-isolering. Jeres lejelister, kontrakter og proformaer anvendes aldrig til offentlig AI-træning.",
    "founderLeadership": "Ledelse",
    "founderName": "Ghazwan Alemara",
    "founderRole": "Grundlægger & Lead Systems Architect · CRE-Dominion",
    "founderSub": "bakket op af Data Genius",
    "founderLinkedIn": "Forbind på LinkedIn",
    "founderBio1": "Ghazwan Alemara er grundlægger og Lead Systems Architect for CRE-Dominion, bakket op af software- og forskningsstudiet Data Genius. Med speciale i enterprise systemarkitektur og kvantitativ software engineering skabte Ghazwan CRE-Dominion for at eliminere informationsasymmetri i erhvervsejendomsadministration og analyse.",
    "founderBio2": "Med en kandidatgrad (M.Sc.) i systemvidenskab fra Stockholms Universitet (EQF Niveau 7) anvender han deterministiske beregningsmodeller til at erstatte manuelle regneark med højkapacitets algoritmisk analyse og automatisk revision.",
    "card1Label": "Uddannelse",
    "card1Val": "M.Sc. Systemvidenskab",
    "card1Sub": "Stockholms Universitet (EQF 7)",
    "card2Label": "Arkitektur",
    "card2Val": "Lead Systems Architect",
    "card2Sub": "Algoritmisk ejendomsintelligens",
    "card3Label": "Udviklingsstudie",
    "card3Val": "Data Genius",
    "card3Sub": "Anvendt system-R&D",
    "card4Label": "Databeskyttelse",
    "card4Val": "Zero-Trust-isolering",
    "card4Sub": "Institutionel databeskyttelse",
    "ctaTitle": "Implementér CRE-Dominion i din ejendomsportefølje",
    "ctaDesc": "Oplev 60-sekunders lejeabstraktion og institutionel underwriting på dine aktive sager med vores pilotprogram.",
    "ctaBtn": "Anmod om institutionel pilot",
    "ctaDemo": "Udforsk 60-sekunders demo",
        "secBadge": "Bankfortrolighed & Datasuverænitet",
    "secTitle": "Institutionel sikkerhed & nul-tillid privatliv",
    "secSub": "Konstrueret specifikt til institutionelle kapitalforvaltere, ejendomsfonde og erhvervsmæglere med følsomme transaktionsdata.",
    "secCard1Title": "Ingen AI-modeltræning",
    "secCard1Desc": "Dine lejekontrakter, lejelister og vurderingsmodeller er strengt isolerede. Vi træner aldrig globale AI-modeller på kundedata.",
    "secCard2Title": "AES-256 & TLS 1.3-kryptering",
    "secCard2Desc": "Alle dokumentarbejdsgange og data krypteres under transport og i hvile med mulighed for automatisk dokumentsletning.",
    "secCard3Title": "Strikt lejeropdeling",
    "secCard3Desc": "Gennemtvingede IAM-adgangsbarrierer på arbejdsområdeniveau. Nul datalækage mellem organisationer med fuld diskretion.",
    "secCard4Title": "SOC-2 & GDPR-parat arkitektur",
    "secCard4Desc": "Fuld overholdelse af EU- og globale databeskyttelsesstandarder, uforanderlige revisionsspor og fuldstændig datakontrol.",
    "pilotBadge": "Institutionel risikoreduktion",
    "pilotTitle": "14-dages institutionelt pilotprogram",
    "pilotSub": "Afprøv CRE-Dominion risikofrit på dine aktive erhvervsejendomme inden en bredere udrulning.",
    "pilotStep1Title": "1. Empirisk lejekontraktbenchmark",
    "pilotStep1Desc": "Upload 5-10 af dine mest komplekse erhvervslejekontrakter. Mål udtrækshastighed, driftsomkostninger og nøjagtighed mod dine egne analytikere.",
    "pilotStep2Title": "2. Tilpasset beregningskalibrering",
    "pilotStep2Desc": "Vi tilpasser værdiansættelsesalgoritmer, DCF-afkastkrav og proforma-rapporter til din investeringskomités standarder.",
    "pilotStep3Title": "3. Direkte arkitekt-SLA",
    "pilotStep3Desc": "Direkte ingeniørkontakt til chefsystemarkitekt Ghazwan Alemara, sub-60 sekunders behandlingstid og prioriteret integration.",
    "footerRights": "CRE-Dominion · Et Data Genius-foretagende. Alle rettigheder forbeholdes."
}
};
